(function ($, Global) {
    var SignupModalComponent = function () {
        // Déclaration class objet
    };

    SignupModalComponent.prototype.initEvents = function () {
        this.subscribers();
    }

    SignupModalComponent.prototype.subscribers = function () {
        var self = this;

        $.Topic('signup-modal-show').subscribe(function (context, options) {
            var origin = options && options.origin ? options.origin : '';
            var redirect = options && options.redirect ? options.redirect : '';
            var idArticle = options && options.idArticle ? options.idArticle : '';
            var modalId = 'modalSignup' + (context || '') + origin;
            
            if ($('#' + modalId).exists()) {
                return $('#' + modalId).modal('show')
            }

            $.Topic('loader-show').publish();
            $.ajaxGet('/ajax/signup' + (context ? '?context=' + context : '') + (origin !== '' ? '&origin=' + origin : '') + (redirect !== '' ? '&redirect=' + redirect : '') + (idArticle !== '' ? '&idArticle=' + idArticle : ''))
                .done(function (result) {
                    Global.ajaxCallback({
                        results: result,
                        success: function () {
                            $('body').append(self.templateModal(result.data.html, modalId, context));
                            $('#' + modalId).modal('show').on('shown.bs.modal', function () {
                                $.Topic('loader-hide').publish();
                            });
                        }
                    });
                })
        });

        $.Topic('confirmation-email-show').subscribe(function () {
            if ($('#emailConfirmation').exists()) {
                return $('#emailConfirmation').modal('show');
            }
        });
    }

    SignupModalComponent.prototype.templateModal = function (contentHtml, id, context) {
        return [
            '<div id="' + id + '" class="modal fade signup-modal' + (context == 'simple-free' ? ' modal-simple' : '') +'" tabindex="-1" role="dialog">',
            '<div class="modal-dialog" role="document">',
            contentHtml,
            '</div>',
            '</div>'
        ].join('')
    }

    Global.SignupModalComponent = SignupModalComponent;
}(jQuery, window));